module.exports = __webpack_public_path__ + "img/1.1.23135d74.jpg";